const FieldKeyConstants = {
  /** Names */
  SSN_NUMBER: 'socialSecurityNumber',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  FIRST_NAME_PHONETIC: 'firstNamePhonetic',
  LAST_NAME_PHONETIC: 'lastNamePhonetic',
  FULL_NAME: 'fullName',
  FULL_NAME_PHONETIC: 'fullNamePhonetic',
  ALTERNATE_COLLECTION_FIRST_NAME: 'alternateCollectorFirstName',
  ALTERNATE_COLLECTION_SUR_NAME: 'alternateCollectorSurName',
  SECOND_SUR_NAME: 'secondSurname',
  SECOND_LAST_NAME: 'secondLastName',
  BIRTH_DATE: 'birthDate',
  PREFERRED_LANGUAGE: 'preferredLanguage',

  /** Address */
  ADDRESS_LINE1: 'address1',
  ADDRESS_LINE2: 'address2',
  ADDRESS_LINE3: 'address3',
  ADDRESS_LINE4: 'address4',
  ADDRESS_LINE5: 'address5',
  ADDRESS_LINE6: 'address6',
  CITY: 'cityName',
  POST_CODE: 'zipCode',

  HOUSE_NUMBER: 'houseNumber',
  STATE: 'state',
  COUNTRY_CODE: 'countryCode',

  /** Delivery Address */
  SHIPPING_FIRST_NAME: 'shippingFirstName',
  SHIPPING_LAST_NAME: 'shippingLastName',
  SHIPPING_ADDRESS_LINE1: 'shippingAddressLine1',
  SHIPPING_ADDRESS_LINE2: 'shippingAddressLine2',
  SHIPPING_ADDRESS_LINE3: 'shippingAddressLine3',
  SHIPPING_ADDRESS_CITY: 'shippingCity',
  SHIPPING_POST_CODE: 'shippingZipCode',
  SHIPPING_STATE: 'shippingState',
  SHIPPING_COUNTRY_CODE: 'shippingCountryCode',
  SHIPPING_MOBILE: 'shippingMobileNumber',
  SHIPPING_LANDLINE: 'shippingLandLine',
  SHIPPING_EMAIL: 'shippingEmail',

  /** Contact */
  EMAIL: 'username',
  MOBILE: 'mobile',
  LANDLINE: 'landline',

  /** Business */
  BUSINESS_NAME: 'businessName',
  ORGANIZATION_NUMBER: 'organizationNumber',
  BUSINESS_NAME_PHONETIC: 'businessNamePhonetic',
  FISCAL_CODE: 'fiscalCode',
  TAX_CODE: 'taxId.documentNumber',
  REGULAR_TAX_CODE_TYPE: 'regularTaxCodeType',
  BUSINESS_TAX_CODE_TYPE: 'businessTaxCodeType',
  TAX_IDENTIFIER_NUMBER: 'taxIdentifierNo',
  VAT_BUSINESS_TYPE: 'vatBusinessType',
  BILLING_VAT_PAYING_BUSINESS: 'billingVatPayingBusiness',
  SHIPPING_VAT_PAYING_BUSINESS: 'shippingVatPayingBusiness',

  /** Recipient */
  RECIPIENT_CODE: 'recipientCode',
  RECIPIENT_EMAIL: 'recipientEmail'
};

export default FieldKeyConstants;
